export class EmployeeAdminTaskAddressUpdate {
    taskId: string;
    streetAddressNameNumberAndLetter: string;
    zipCode: string;

    constructor(taskId: string, address: string, zipCode: string) {
        this.taskId = taskId;
        this.streetAddressNameNumberAndLetter = address;
        this.zipCode = zipCode;
    }
}
